export type EditorPromoCodeState = ObjectValues<typeof EDITOR_PROMO_CODE_STATE>

export const EDITOR_PROMO_CODE_STATE = {
  Active: 'active',
  AlmostThere: 'almostthere',
  Closed: 'closed',
  Error: 'error',
  Open: 'open',
} as const

export type EditorPromoCodeResultVariant = Extract<EditorPromoCodeState, 'active' | 'almostthere'>

export const EDITOR_PROMO_CODE_MOTION = {
  rotate: '300ms',
  tint: '260ms',
} as const
